// extracted by mini-css-extract-plugin
module.exports = {"list":"CreateBaseStorageMoveModal_list__3O9DP"};